<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardtwo.hardware-title1') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li1') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li2') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li3') }}</div>
      <div class="hardware-title">{{ $t('hardtwo.hardware-title2') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li4') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li5') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li6') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li7') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li8') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li9') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li10') }}</div>
      <div class="hardware-title">{{ $t('hardtwo.hardware-title3') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li11') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li12') }}</div>
      <div class="hardware-title">{{ $t('hardtwo.hardware-title4') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li13') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li14') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li15') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li16') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li17') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li18') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li19') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li20') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li21') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li22') }}</div>
      <div class="hardware-title">{{ $t('hardtwo.hardware-title5') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li23') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li24') }}</div>
      <div class="hardware-li">{{ $t('hardtwo.hardware-li25') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>